import { Component, Inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { datepickerValueToDate } from 'src/app/shared/functions/datepicker-value-to-date';
import { UiDateRangeValue } from 'src/app/shared/ui-elements/ui-date-range-picker/ui-date-range-picker.component';

export interface DashboardCustomRangeDialogData {
  range: UiDateRangeValue | null;
  maxDate: Date;
}

@Component({
  selector: 'app-dashboard-custom-range-dialog',
  templateUrl: './dashboard-custom-range-dialog.component.html',
  styleUrls: ['./dashboard-custom-range-dialog.component.scss'],
  standalone: false,
})
export class DashboardCustomRangeDialogComponent {
  fromControl = new FormControl<Date | null>(this.data.range?.from ?? null);
  toControl = new FormControl<Date | null>(this.data.range?.to ?? null);

  constructor(
    @Inject(MAT_DIALOG_DATA) readonly data: DashboardCustomRangeDialogData,
    private dialogRef: MatDialogRef<DashboardCustomRangeDialogComponent>
  ) {}

  getFromMaxDate(): Date {
    const toDate = this.toControl.value
      ? datepickerValueToDate(this.toControl.value)
      : this.data.maxDate;
    return toDate < this.data.maxDate ? toDate : this.data.maxDate;
  }

  getToMinDate(): Date | null {
    return this.fromControl.value ? datepickerValueToDate(this.fromControl.value) : null;
  }

  isRangeValid(): boolean {
    if (!this.fromControl.value || !this.toControl.value) {
      return false;
    }

    return (
      datepickerValueToDate(this.fromControl.value) <= datepickerValueToDate(this.toControl.value)
    );
  }

  cancel(): void {
    this.dialogRef.close();
  }

  apply(): void {
    if (!this.isRangeValid() || !this.fromControl.value || !this.toControl.value) {
      return;
    }

    this.dialogRef.close({
      from: datepickerValueToDate(this.fromControl.value),
      to: datepickerValueToDate(this.toControl.value),
    } satisfies UiDateRangeValue);
  }
}
